export default __webpack_public_path__ + "static/media/scene.8a505e4a.mp4";